import {
  logout as logoutApi,
} from '../../shared/api';
import { fetchingError } from '../../shared/store/actions';
import { errorNotification } from '../../shared/store/notificationActions';

import {
  updateUserPreferences as updateUserPreferencesApi,
  updateUserLastClient as updateUserLastClientApi,
} from '../api';

import { userPreferencesModal } from '../userProfile/modalNames';
import getModalActions from '../../shared/modals/getModalActions';


import {
  LOGOUT,
  LOGOUT_SUCCESS,
  UPDATE_USER_PREFERENCES,
  UPDATE_USER_PREFERENCES_SUCCESS,
  UPDATE_USER_PREFERENCES_FAILURE,
  SWITCH_CLIENT,
  UPDATE_USER_LAST_CLIENT,
  UPDATE_USER_LAST_CLIENT_SUCCESS,
  UPDATE_USER_LAST_CLIENT_FAILURE,
} from './types';

const {
  showAction: showUserPreferencesModal,
  hideAction: hideUserPreferencesModal,
} = getModalActions(userPreferencesModal);

export const logout = () => async dispatch => {
  dispatch({
    type: LOGOUT,
  });

  try {
    const logoutData = await logoutApi();

    return dispatch({
      type: LOGOUT_SUCCESS,
      logoutData,
    });
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      return dispatch(errorNotification(error.message));
    }
    throw error;
  }
};

export const updateUserPreferences = preferences => async dispatch => {
  dispatch({
    type: UPDATE_USER_PREFERENCES,
  });

  try {
    await updateUserPreferencesApi(preferences);

    dispatch({
      type: UPDATE_USER_PREFERENCES_SUCCESS,
      preferences,
    });
    return dispatch(hideUserPreferencesModal());
  } catch (error) {
    if (error.isFetchingError) {
      dispatch({
        type: UPDATE_USER_PREFERENCES_FAILURE,
      });
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const updateUserLastClient = clientId => async dispatch => {
  dispatch({
    type: UPDATE_USER_LAST_CLIENT,
  });

  try {
    await updateUserLastClientApi(clientId);

    return dispatch({
      type: UPDATE_USER_LAST_CLIENT_SUCCESS,
    });
  } catch (error) {
    if (error.isFetchingError) {
      dispatch({
        type: UPDATE_USER_LAST_CLIENT_FAILURE,
      });
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const switchClient = clientId => async dispatch => {
  dispatch({
    type: SWITCH_CLIENT,
    clientId,
  });

  await dispatch(updateUserLastClient(clientId));
};

export {
  showUserPreferencesModal,
  hideUserPreferencesModal,
};
